import { defineMessages } from 'react-intl';

export const scope = 'edit_chatbot';

export default defineMessages({
    configuration_error: {
        id: `${scope}.configuration_error`,
        defaultMessage: 'Chatbot configuration not found.',
    },
    field_check: {
        id: `${scope}.field_check`,
        defaultMessage: 'All fields are required.',
    },
    auth_error: {
        id: `${scope}.auth_error`,
        defaultMessage: 'Authorization failed. Please try again later.',
    },
    update_error: {
        id: `${scope}.update_error`,
        defaultMessage: 'Failed to update app. Please try again.',
    },
    update_success: {
        id: `${scope}.update_success`,
        defaultMessage: 'App updated successfully.',
    },
    dataset_error: {
        id: `${scope}.dataset_error`,
        defaultMessage: 'Please select at least one dataset and try again.',
    },
    lauch_error: {
        id: `${scope}.lauch_error`,
        defaultMessage: 'Failed to launch. Please try again.',
    },
});
